module.exports = __webpack_public_path__ + "static/media/polar.0d2f0f90.png";